/* eslint-disable jsx-a11y/img-redundant-alt */
import React, {useEffect, useState} from "react";
import { Avatar_02, Avatar_16 } from "Routes/ImagePath";
import { Link } from "react-router-dom";
import Breadcrumbs from "components/Breadcrumbs";
import {useNavigate, useLocation, useParams} from "react-router-dom"
import { getAssetDetailApi, returnAssetApi } from "api/services/assets";
import AssetAttachment from "./AssetAttachment";
import { getEmployeeDetailApi } from "api/services/employee";
import { formatDateHandler2 } from "utils/common";
import AllAssetAddPopup from "components/modelpopup/AllAssetAddPopup";
import AssetAssignPopup from "components/modelpopup/assignAssetPopup";
import {  toast, Bounce } from 'react-toastify';
import ReturnAssetModal from "components/modelpopup/ReturnAssetModal";

import { useAssets } from "./../context/assetContext";
import Image from "components/Image";

const AssetDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  const [assetData, setAssetData] = useState({})
  const [attachmentData, setAttachmentData] = useState([]) 
  const [returnAssetModal, setReturnAssetModal] = useState(false)

    useEffect(()=>{
    console.log(location,navigate,params, "LLL")

if(params?.id){
  fetchAssetDetail(params?.id)
}
  },[params?.id])

  const fetchAssetDetail = (id) => {
    getAssetDetailApi(id).then(response=>{
      console.log(response, "REEEEEEE")
      setAssetData(response.data)
      setAttachmentData([{url:response.data?.image}])
    })
  }
   const {
      loading,
      searchText,

      view,
      setView,
      
      pageSettings,
      handleGridChange,
      handleChange,
      handleSearchChange,
      handleFilterDrawer,
      showFilterDrawer,
  
      handleFilterChange,
      filters,
      handleInputChange,
      handleApplyFilter,
      filterLoading,
      
      handleAssetDetailPage,
      handleDateChange,
      getAssetList,
      setLoading,
      assetCategory
    } = useAssets();

const [selectedAsset, setSelectedAsset] = useState()
const [assetModal, setAssetModal] = useState(false)



const [selectedAssetUser, setSelectedAssetUser] = useState()
const [assetUserModal, setAssetUserModal] = useState(false)


const returnAssetHandler = (props) => {
  console.log(selectedAssetUser, "LLLLLLLL")
  returnAssetApi(selectedAssetUser?.id, {
    approval_status: "",
    comment: ""
  }).then(res=>{
    toast.success('Asset return request initiated successfully!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
      });

      fetchAssetDetail(assetData?.id)
      setReturnAssetModal(false)
  }).catch(e=>{
    toast.error('Error initiating asset return!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
      });
  })
}

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Asset Details"
            title="Assets"
            subtitle="Asset Detail"
            modal="#add_indicator"
            name="Add New"
            showModal={false}
            setAssetModal={setAssetModal}
            linkName="/assets"
          />
          <div className="card mb-0">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="profile-view">
                    {/* <div className="profile-img-wrap">
                      <div className="profile-img">
                        <Link to="#">
                          <Image src={assetData?.image} type="object" />
                        </Link>
                      </div>
                    </div> */}
                         <div className="pro-edit">
                                         <Link
                                         onClick={()=>{
                                           setSelectedAsset(assetData)
                                          setAssetModal(true)
                                         }}
                                           // data-bs-target="#profile_info"
                                           // data-bs-toggle="modal"
                                           className="edit-icon"
                                           // to="#"
                                         >
                                           <i className="fa-solid fa-pencil"></i>
                                         </Link>
                                       </div>

                    <div className="">
                      {/* <div className="row  mt-4">
                        <div className="col-md-12">
                          <div>
                            <h3 className="user-name m-t-0 mb-0">
                              {assetData?.user?.first_name} {assetData?.user?.last_name}
                            </h3>
                            <h6 className="text-muted">{assetData?.user?.position_name}</h6>
                          
                            <div className="staff-id">
                              Email : {assetData?.user?.email}
                            </div>                      
                           
                            </div>
                            <div className="small doj text-muted">
                              Date of Join : {formatDateHandler2(userData?.employment?.employment_date)}
                            </div>
                            <div className="staff-msg">
                              <Link className="btn btn-custom" to="/call/chat">
                                Send Message
                              </Link>
                            </div>
                          </div>
                        </div> */}
                        <div className="col-md-7 mt-2">
                          <ul className="personal-info">                            
                            <li>
                              <div className="title">Asset Name:</div>
                              <div className="text">                             
                                  {assetData?.name}                              
                              </div>
                            </li>
                            <li>
                              <div className="title">Asset Description:</div>
                              <div className="text">                             
                                  {assetData?.description}                              
                              </div>
                            </li>
                            <li>
                              <div className="title">FA No:</div>
                              <div className="text">                          
                                  {assetData?.ext_id}                             
                              </div>
                            </li>
                            <li>
                              <div className="title">FA Code:</div>
                              <div className="text">                          
                                  {assetData?.class_code}                             
                              </div>
                            </li>
                            <li>
                              <div className="title">Brand:</div>
                              <div className="text"> 
                              <span className={`badge badge-soft-warning`}>{assetData?.brand} </span>                              
                                                               
                              </div>
                            </li>
                            {/* <li>
                              <div className="title">Model:</div>
                              <div className="text">                             
                                  {assetData?.model_number}                              
                              </div>
                            </li> */}
                            <li>
                              <div className="title">Serial Number:</div>
                              <div className="text">                             
                                  {assetData?.serial_number|| "-"}                              
                              </div>
                            </li>
                            {/* <li>
                              <div className="title">Current Value:</div>
                              <div className="text">                             
                                  {assetData?.current_value}                              
                              </div>
                            </li> */}
                            <li>
                              <div className="title">Purchase Date:</div>
                              <div className="text">                             
                                  {formatDateHandler2(assetData?.purchase_date) || "-"}                              
                              </div>
                            </li>
                            <li>
                              <div className="title">Purchase Value:</div>
                              <div className="text">                             
                                  {assetData?.purchase_value}                              
                              </div>
                            </li>
                            
                            
                          
                         <li>
                              <div className="title">Status:</div>
                              <div className="text">                            
                                 
                                  <div className="grid-badges">
                                      <span className={`badge badge-soft-${assetData?.status ? "success":"danger"}`}>{assetData?.status ? "ACTIVE" : "INACTIVE"}</span>
                                  </div>                              
                              </div>
                            </li>
                          
                          </ul>
                        </div>
                      </div>

                      <div className="mt-2 row">                     
                        <div className="col-md-12">
                           <AssetAttachment assetData={attachmentData} />                
                        </div>
                     </div>

                     <div className="" >
                      <div className="d-flex justify-content-between my-3" >
                      <div className="title">History</div>
                      <div className="title">
                      <Link
                          onClick={()=>{
                          //   setSelectedAsset(assetData)
                          setAssetUserModal(true)
                          setSelectedAssetUser("")
                          }}
                            // data-bs-target="#profile_info"
                            // data-bs-toggle="modal"
                            // className="edit-icon"
                            // to="#"
                          >
                            <i className="la la-edit"></i> Reassign/Assign Asset
                          </Link>
                      </div>
                      

                      </div>
                     <div className=" row" >


                    

                     {
                      assetData?.user_assets?.map(item=>{
                        return(
                          <div className="col-xxl-3 col-xl-4 col-md-6">
                            <Link
                                         onClick={()=>{
                                          setSelectedAssetUser(item)

                                          //  setSelectedAsset(assetData)
                                          setAssetUserModal(true)
                                         }}
                                           // data-bs-target="#profile_info"
                                           // data-bs-toggle="modal"
                                           className="edit-icon m-2"
                                           // to="#"
                                         >
                                           <i className="fa-solid fa-pencil"></i>
                                         </Link>
                                         {
                                          item.status &&
                                          <Link
                                          onClick={()=>{
                                           setSelectedAssetUser(item)
                                           setReturnAssetModal(true)
                                          }}
                                            // data-bs-target="#profile_info"
                                            // data-bs-toggle="modal"
                                            className="edit-icon m-2"
                                            // to="#"
                                          >
                                           <i class="fa-solid fa-arrow-rotate-left"></i>
                                          </Link>
                                         }
                                        
                          <div className="contact-grid p-3">
                          
                              <div className="grid-head" onClick={()=>{
                                          setSelectedAssetUser(item)

                                          //  setSelectedAsset(assetData)
                                          setAssetUserModal(true)
                                         }}>
                                  <div className="users-profile">
                                      <a  className="avatar">
                                          {/* <img src={employee?.profile_image} alt="" /> */}
                                          <Image  src={item?.company_user?.profile_image} type="user" alt="User Image" style={{ objectFit: "cover" }} />
                                      </a>
                                      <h5 className="name-user">
                                          <a >{item?.company_user?.first_name} {item?.company_user?.last_name}</a>
                                          <span>{item?.company_user?.emp_no}</span>
                                      </h5>
                                  </div>
                             
                              </div>
                              <div className="grid-body">
                                  <div className="address-info">
                                      
                                      <span>
                                          <i className="la la-calendar" />
                                          Issue Date : {formatDateHandler2(item?.issue_date)}
                                      </span>
                                      <span>
                                          <i className="la la-calendar" />
                                          Return Date : {formatDateHandler2(item?.return_date) }
                                      </span>
                                      <span  >
                                          <i className="la la-comment" />
                                          Comment : {item?.comment}
                                          {/* sharon@gmail.com */}
                                      </span>
                                      {/* {
                                        item?.current_approver &&
                                        <span  >
                                          <i class="fa-solid fa-user-tie"></i>
                                          Next Approver :  {item?.current_approver?.first_name||""} {item?.current_approver?.last_name||""}
                                      </span>
                                      } */}
                                      
                                      {/* <span>
                                          <i className="la la-map-marker" />
                                          {employee?.nationality?.name}
                                      </span> */}
                                  </div>
                                  <div className="grid-badges">
                                      <span className={`badge badge-soft-${item?.status ? "success":"danger"}`}>{item?.status ? "Assigned" : "Not Assigned"}</span>
                                  </div>
                              </div>
                             
                          </div>
                      </div>
                        )
                      })

                     }
                      </div>
                     </div>
                    </div>
                 

                    <AllAssetAddPopup getAssetList={()=>handleAssetDetailPage(selectedAsset.id, 1)} assetCategory={assetCategory}  setSelectedAsset={setSelectedAsset} setLoading={setLoading} selectedAsset={selectedAsset} loading={loading} assetModal={assetModal} setAssetModal={setAssetModal} />
                    <AssetAssignPopup 
                    selectedAsset={assetData}
                    getAssetList={()=>fetchAssetDetail(assetData.id, 1)}  
                      setSelectedAssetUser={setSelectedAssetUser} 
                      setLoading={setLoading}
                       selectedAssetUser={selectedAssetUser} 
                       loading={loading} 
                       assetUserModal={assetUserModal} 
                       setAssetUserModal={setAssetUserModal}/>

                <ReturnAssetModal returnAssetModal={returnAssetModal} setReturnAssetModal={setReturnAssetModal} returnAssetHandler={returnAssetHandler} Name="Return Asset" />


                  </div>
                </div>
              </div>
            </div>
          </div>     

          
        </div>
     
    </>
  );
};

export const ListItem = ({ title, text }) => (
  <li>
    <div className="title">{title}</div>
    <div className="text">{text}</div>
  </li>
);


export default AssetDetails;
